import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ExpandMoreProps {
  expand: number;
}

interface WrapperProps {
  error: number;
}

export const Wrapper = styled(Box)<WrapperProps>(({ error }) => ({
  border: `1px solid ${error ? '#F44336' : 'rgba(221, 221, 234, 1)'}`,
  padding: '4px 4px 0px 9px',
  borderRadius: '6px',
}));

export const ExpandMore = styled(IconButton)<ExpandMoreProps>(
  ({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),

    '.MuiSvgIcon-root': {
      fill: expand ? 'rgba(34, 40, 34, 1)' : 'rgba(159, 159, 159, 1)',
    },
  }),
);

export const CollapseHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  cursor: 'pointer',
  marginBottom: '4px',

  '&:hover .MuiButtonBase-root .MuiSvgIcon-root': {
    fill: 'rgba(34, 40, 34, 1)',
  },
}));

export const CollapseContent = styled(Collapse)(() => ({
  overflow: 'auto',
}));

export const TitleContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',

  '.MuiTypography-root': {
    fontSize: '16px',
    lineHeight: '20.8px',
    fontWeight: 600,
  },

  '>svg': {
    minWidth: '24px',
  },
}));

export const LoaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '30px 0',
}));

export const Count = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '18.2px',
  fontSize: '14px',
  fontWeight: '600',
  background: 'rgba(221, 221, 234, 1)',
  borderRadius: '50%',
  height: '20px',
  minWidth: '20px',
}));

export const IconsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
}));
